import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";

const DISMISS_KEY = "alerts_optin_banner_dismissed";

export default function AlertsOptinBanner() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });

  if (!user || user === false) return null;
  if (user.role !== "particular") return null;
  if (user.alerts_optin) return null;
  if (dismissed) return null;

  const enable = async () => {
    setBusy(true);
    try {
      await api.patch("/auth/me", { alerts_optin: true });
      await refresh();
      toast.success("Alertes activées ! Vous serez notifié·e des nouvelles offres.");
    } catch {
      toast.error("Impossible d'activer les alertes");
    } finally {
      setBusy(false);
    }
  };

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch {}
    setDismissed(true);
  };

  return (
    <div className="bg-gradient-to-r from-[#E05638] to-[#f0764c] text-white" data-testid="alerts-optin-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <BellRing size={18} className="shrink-0 hidden sm:block"/>
        <div className="flex-1 text-sm">
          <span className="font-semibold">Ne ratez plus aucun bon plan.</span>{" "}
          <span className="opacity-90">Recevez un email dès qu'une nouvelle offre est publiée dans votre pôle.</span>
        </div>
        <button
          onClick={enable}
          disabled={busy}
          data-testid="alerts-optin-enable-btn"
          className="shrink-0 bg-white text-[#E05638] hover:bg-orange-50 font-semibold text-xs sm:text-sm px-3 sm:px-4 py-1.5 rounded-full transition-colors disabled:opacity-50"
        >
          {busy ? "…" : "Activer les alertes"}
        </button>
        <button
          onClick={dismiss}
          data-testid="alerts-optin-dismiss-btn"
          aria-label="Fermer"
          className="shrink-0 p-1 rounded-full hover:bg-white/15 transition-colors"
        >
          <X size={16}/>
        </button>
      </div>
    </div>
  );
}
